import { useMemo, useContext } from "react";
import {
  useEffectivePermissions,
  toSet,
  hasScope,
  can,
} from "../hooks/useEffectivePermissions";
import { AuthContext } from "../context/AuthContext";

export const CHAT_BULK_SCOPE = "chat.bulk";
export const CHAT_EXPORT_SCOPE = "chat.export";

function isPrivilegedBulkUser(userData) {
  if (!userData) return false;
  if (Number(userData.master) === 1) return true;
  const scope = userData.scope;
  return scope === "platform" || scope === "partner";
}

/**
 * Permissões para operações em massa na busca.
 * - chat.bulk, chat.update ou gestaodeleads.update (legado): unificar, distribuir, alterar
 * - chat.export ou chat.view: exportar PDF/CSV
 */
export function useSearchResultsBulkPermissions() {
  const { userData } = useContext(AuthContext);
  const { data: permissionsData } = useEffectivePermissions();
  const scopes = useMemo(() => toSet(permissionsData?.scopes), [permissionsData?.scopes]);
  const isMaster = isPrivilegedBulkUser(userData);

  const canBulk = useMemo(() => {
    if (isMaster) return true;
    if (hasScope(scopes, CHAT_BULK_SCOPE)) return true;
    if (can(scopes, "chat", "update")) return true;
    if (can(scopes, "gestaodeleads", "update")) return true;
    return false;
  }, [isMaster, scopes]);

  const canExport = useMemo(() => {
    if (isMaster) return true;
    if (hasScope(scopes, CHAT_EXPORT_SCOPE)) return true;
    if (can(scopes, "chat", "view")) return true;
    return false;
  }, [isMaster, scopes]);

  return { canBulk, canExport, isMaster };
}
